import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ICONS } from '@/constants/icons.js';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    name: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
  name: string;
  size?: string;
}



const iconSvg = computed(() => ICONS[props.name]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "icon inline-flex align-items-center justify-content-center",
    style: _normalizeStyle([
      __props.size ? { width: __props.size + 'px', height: __props.size + 'px' } : { width: '24px', height: '24px' },
    ]),
    innerHTML: _unref(iconSvg)
  }, null, 12, _hoisted_1))
}
}

})